import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "../lib/appConfig";
import ThemeToggle from "./ThemeToggle";

const LINKS = [
  { to: "/book", label: "Book" },
  { to: "/queue", label: "Live Queue" },
  { to: "/find", label: "My Booking" },
  { to: "/my-health", label: "My Health" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background,box-shadow,padding,border] duration-300 ${
        scrolled ? "glass py-2 border-b border-border" : "bg-transparent py-3 border-b border-transparent"
      }`}>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0" aria-label="CliniQueue home">
          <img src={BRAND.logo} alt="CliniQueue logo" className="h-[80px] w-auto object-contain" />
        </Link>
        

        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => {
            const active = loc.pathname === l.to;
            return (
              <Link key={l.to} to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  active ? "text-primary bg-primary/10" : "text-muted-foreground hover:text-foreground hover:bg-foreground/5"
                }`}>
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <ThemeToggle />
          <button data-testid="nav-book-cta" onClick={() => navigate("/book")}
            className="aurora-gradient text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-[box-shadow,transform] duration-300 hover:scale-[1.03] aurora-ring btn-shine">
            Book Appointment
          </button>
        </div>

        <div className="md:hidden flex items-center gap-2">
          <ThemeToggle />
          <button data-testid="nav-mobile-toggle"
            className="p-2 rounded-full hover:bg-foreground/5 text-foreground"
            onClick={() => setOpen((o) => !o)} aria-label="Menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden mt-3 mx-4 glass rounded-3xl p-4">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="block px-4 py-3 rounded-2xl text-foreground/90 font-medium hover:bg-foreground/5">
              {l.label}
            </Link>
          ))}
          <button onClick={() => navigate("/book")} className="mt-2 w-full aurora-gradient text-white font-semibold px-5 py-3 rounded-full">
            Book Appointment
          </button>
        </div>
      )}
    </header>
  );
}
